<script setup lang="ts">
import { computed } from 'vue';
import UiText from './UiText.vue';

export interface SeTagProps {
    text: string;
    variant?: 'primary' | 'secondary' | 'rounded' | 'dark';
    narrow?: boolean;
}

const props = withDefaults(defineProps<SeTagProps>(), {
    variant: 'primary',
});

const tagClasses = computed(() => {
    switch (props.variant) {
        case 'rounded':
            return 'bg-se-primary text-se-dark px-2 py-0.5 rounded-sm';
        case 'secondary':
            return 'bg-se-secondary text-se-dark py-0.5';
        case 'dark':
            return 'bg-se-dark text-se-white px-1 rounded-sm';
        default:
            return 'bg-se-primary text-se-dark px-2 py-0.5';
    }
});
</script>

<template>
    <div class="inline-flex items-center justify-center" :class="tagClasses">
        <UiText :text="props.text" as="caption" class="font-semibold" :class="!props.narrow ? 'se-tracking-caption' : ''" />
    </div>
</template>